import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

interface PopupProps {
  isOpen: boolean;
  type: string;
  title?: string;
  description: string;
  onPressSubmit: any;
  onPressCancel?: any;
}

export function Popup({
  isOpen,
  title,
  type = "confirm",
  description,
  onPressSubmit,
  onPressCancel,
}: PopupProps) {
  return (
    <div>
      <Modal isOpen={isOpen}>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{description}</ModalBody>
        {type === 'confirm' && <ModalFooter>
          <Button color="success" onClick={onPressSubmit}>
            Okay
          </Button>
          {" "}
          <Button color="danger" onClick={onPressCancel}>
            Cancel
          </Button>{" "}
        </ModalFooter>}
        {type === 'error' && <ModalFooter>
          <Button color="primary" onClick={onPressSubmit}>
            Okay
          </Button>
        </ModalFooter>}
        {type === 'info' && <ModalFooter>
          <Button color="primary" onClick={onPressSubmit}>
            Okay
          </Button>
        </ModalFooter>}
      </Modal>
    </div>
  );
}
